// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-result {
  /* Typography */
  --perxis-auto-result-text-transform-inner: var(--perxis-auto-result-text-transform, none);
  --perxis-auto-result-font-weight-inner: var(--perxis-auto-result-font-weight, 400);
  --perxis-auto-result-icon-color-inner: var(--perxis-auto-result-icon-color, var(--perxis-auto-root-typography-color-light-colorful-inner));
  /* End Typography */
}
.perxis-auto-1_16_0-result .ant-5_17_0-result-icon {
  margin-bottom: var(--perxis-auto-gap-vertical-yellow-inner);
}
.perxis-auto-1_16_0-result .ant-5_17_0-result-icon .perxis-auto-1_16_0-icon {
  color: var(--perxis-auto-result-icon-color-inner);
}
.perxis-auto-1_16_0-result .ant-5_17_0-result-title {
  margin-top: 0;
  margin-bottom: var(--perxis-auto-gap-vertical-yellow-inner);
}
.perxis-auto-1_16_0-result .ant-5_17_0-result-subtitle {
  margin-bottom: var(--perxis-auto-gap-vertical-yellow-inner);
  --perxis-auto-typography-h4-font-weight: var(--perxis-auto-result-font-weight-inner);
  --perxis-auto-typography-h4-text-transform: var(--perxis-auto-result-text-transform-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
